const HISTORY_ACCESS_FEE = 200n;
export {
  HISTORY_ACCESS_FEE
};
//# sourceMappingURL=constants.js.map